module.exports = __webpack_public_path__ + "media/images/bg/patterns/husk-5dbf334cf9192f47aab62c7f5b9a7ce6.svg";